export default "__VITE_ASSET__BZuOPb4a__"